















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { fetchClientes } from './fetchClientes';

@Component
export default class TablaInfoGral extends Vue {
  @Prop({ default: [] }) cliente: any;

  fetchClientes = new fetchClientes();

  btnTxt: String = 'GUARDAR CAMBIOS';
  editing: Boolean = false;
  $snotify: any;

  nombre: String;
  rut: String;
  giro: String;
  estado: String;

  handleName(evt: String) {
    this.nombre = evt;
    this.editing = true;
    this.saveEdit();
  }

  handleRut(evt: String) {
    this.rut = evt;
    this.editing = true;
    this.saveEdit();
  }

  handleGiro(evt: String) {
    this.giro = evt;
    this.editing = true;
    this.saveEdit();
  }

  handleEstado(evt: String) {
    this.estado = evt;
    this.editing = true;
    this.saveEdit();
  }

  saveEdit() {
    // this.btnTxt = 'GUARDANDO CAMBIOS...';
    if (this.nombre) this.cliente.nombre = this.nombre;
    if (this.giro) this.cliente.giro = this.giro;
    if (this.estado) this.cliente.estado = this.estado;
    if (this.rut) this.cliente.rut = this.rut;
    else this.cliente.rut = this.cliente.rut.split('-')[0];
    this.cliente.mod = true;
    // this.editing = false;
    this.$emit('guardar', this.cliente);
    // let response = await this.fetchClientes.updateCliente(this.cliente);
    // if (response.data.CODIGO_RESPUESTA === '1') {
    //   this.$snotify.success(response.data.MENSAJE_RESPUESTA);
    // } else {
    //   this.$snotify.error(response.data.MENSAJE_RESPUESTA);
    // }
    // this.btnTxt = 'GUARDAR CAMBIOS';
  }
}
